<div class="row d-flex align-items-center u-full-width">
	<a mat-button class="app-navigation-button col-xs-12 col-md-6 col-lg-3 py-3 px-4 m-0 mat-headline-6"
		 color="accent" routerLink="equipment" i18n>Equipment Konfigurator</a>
	<a mat-button class="app-navigation-button col-xs-12 col-md-6 col-lg-3 py-3 px-4 m-0 mat-headline-6"
		 color="accent" routerLink="software" i18n>Schweißprogrammauswahl</a>
	<a mat-button class="app-navigation-button col-xs-12 col-md-6 col-lg-3 py-3 px-4 m-0 mat-headline-6"
		 color="accent" routerLink="article" i18n>Artikelsuche</a>
	<a mat-button class="app-navigation-button col-xs-12 col-md-6 col-lg-3 py-3 px-4 m-0 mat-headline-6" color="accent"
		 *ngIf="userInfo?.anonymous === false" routerLink="configuration" i18n>Konfigurationen & Listen</a>
</div>
